module.exports = __webpack_public_path__ + "static/media/flag-VI.bd9d3eb6.svg";